<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CContainer>
      <CRow class="mt-5">
        <CCol>
          <CCardGroup>
            <CCard>
              <CCardHeader>
                 <BIconBack/> 초기 단말기 통신을 위한 기본키를 생성하고 다운로드 합니다.
              </CCardHeader>
              <CCardBody>

                <CRow class="m-1">
                  <CCol>
                    <BInputGroup prepend="장비번호">
                      <BFormInput id="mid"
                                  :state="isValidExp(mid, 'hex', 4)"
                                  maxLength="4"
                                  v-model="mid"
                                  required/>

                    </BInputGroup>
                  </CCol>
                  <CCol>
                    <BInputGroup prepend="단말 EUI">
                      <BFormInput id="devId"
                                  :state="isValidExp(linkDevId, 'hex', 16)"
                                  maxLength="16"
                                  v-model="linkDevId"
                                  required/>

                    </BInputGroup>
                  </CCol>

                </CRow>

                <CRow class="m-1">
                  <CCol>
                    <BInputGroup prepend="발급일">
                      <BFormInput type="date"
                                  v-model="keyIssAt"
                      />
                    </BInputGroup>

                  </CCol>
                  <CCol>
                    <BInputGroup prepend="만료일">
                      <BFormInput id="keyEndAt"
                                  type="date"
                                  v-model="keyEndAt"
                      />
                    </BInputGroup>
                  </CCol>
                </CRow>


                <CCard class="m-3" border-color="info">
                  <CCardBody>

                  <CRow class="m-1 mt-3">
                    <CCol>
                      <BInputGroup prepend="Device Key">
                        <BFormInput id="devKey"
                                    v-model="devKey"
                                    />
                      </BInputGroup>
                    </CCol>
                  </CRow>
                  <CRow class="m-1">
                      <CCol>
                        <BInputGroup prepend="Device Key (plain)">
                          <BFormInput id="plainDevKey"
                                      v-model="plainDevKey"
                          />
                        </BInputGroup>
                      </CCol>
                    </CRow>
                  <CRow class="m-1">
                    <CCol>
                      <BInputGroup prepend="Device IV">
                        <BFormInput id="devIv"
                                    v-model="devIv"
                                    maxLength="32"
                        />
                      </BInputGroup>
                    </CCol>
                  </CRow>

                    <CRow class="m-1 mt-3">
                      <CCol>
                        <BInputGroup  prepend="Key Encrypt Key">
                          <BFormInput id="keKey"
                                      v-model="kek"
                          />
                        </BInputGroup>
                      </CCol>
                    </CRow>

                    <CRow class="m-1">
                      <CCol>
                        <BInputGroup prepend="Key Encrypt Key IV">
                          <BFormInput id="keKey"
                                      v-model="keIv"
                          />
                        </BInputGroup>
                      </CCol>
                    </CRow>



                  </CCardBody>
                </CCard>

                <CRow class="m-1 mt-4">
                  <CCol>
                    <BButtonGroup>
                      <BButton variant="warning" class="mr-3" @click='createDefaultKey'><BIconAppIndicator/> 초기화 키 생성</BButton>
                      <BButton variant="danger" @click='downloadDefaultKey'><BIconSave2Fill/> 다운로드</BButton>
                    </BButtonGroup>
                  </CCol>
                </CRow>


              </CCardBody>

            </CCard>


          </CCardGroup>
        </CCol>


      </CRow>

    </CContainer>
  </div>
</template>

<script>
import '@/common/HelperMixin';
import {apiCall} from '@/common/utils';
import moment from "moment";


export default {
  name: 'DefaultKey',
  props: {},

  data(){
    return {
      linkDevId: '',
      mid: '',
      kek: '',
      keIv: '',
      devKey: '',
      plainDevKey: '',
      devIv: '',
      keyIssAt: moment().format('YYYY-MM-DD'),
      keyEndAt: moment().add(1, 'year').format('YYYY-MM-DD'),
      result: '',

    }
  },
  async created(){

  },
  beforeMount(){},
  mounted() {},

  computed: {},

  methods: {
    async createDefaultKey(){
      try{
        const param = {
          linkDevId: this.linkDevId,
          keyIssAt: this.keyIssAt,
          keyEndAt: this.keyEndAt,
          mid: this.mid,
        }

        if(!this.linkDevId){ alert('단말EUI 값 없음'); return}
        if(!this.mid){ alert('장비번호 값 없음'); return}

        const rs = await apiCall('post', `/api/machine/default-key`, param);
        if(rs.code !== 200){
          alert(rs.message);
        }else{
          const {result} = rs;
          this.kek  = result.kek;
          this.keIv = result.keIv;
          this.devKey = result.devKey;
          this.plainDevKey = result.plainDevKey;
          this.devIv = result.devIv;
        }

      }catch(error){
        console.error(error);
      }
    },

    async downloadDefaultKey(){
      try{

        if(!this.linkDevId){ alert('단말EUI 값 없음'); return}
        if(!this.mid){ alert('장비번호 값 없음'); return}


        const param = {
          linkDevId: this.linkDevId,
          keyIssAt: this.keyIssAt,
          keyEndAt: this.keyEndAt,
          mid: this.mid,
        }



        const fileName = `${this.mid}-${this.linkDevId}-${moment().format('YYYYMMDD')}-default.key`;
        console.log('exportKey()---->', fileName);
        const rs = await apiCall('POSTFILE', `/api/machine/default-key-download`, param);
        console.log( 'export key result --->', rs );
        await this.getDownload( fileName, rs );

      }catch(error){
        console.error(error);
      }
    },

  }
}
</script>
